import React from "react";

import { IDimensions } from "Venues/types";
import { IUnitType } from "shared/types";
import { DistanceUnits, useUnitType } from "shared/utils";

import { Dimensions as DimensionsComponent } from "../components/Dimensions";
import { hasDimensions } from "../utils";

interface DimensionsProps {
  dimensions?: IDimensions;
}

export const Dimensions: React.FC<DimensionsProps> = ({ dimensions }) => {
  const { unitType } = useUnitType();

  if (!dimensions || !hasDimensions(dimensions)) return null;

  return (
    <DimensionsComponent
      dimensions={dimensions}
      toUnit={unitType === IUnitType.metric ? DistanceUnits.m : DistanceUnits.ft}
    />
  );
};
